import { render, staticRenderFns } from "./LabsSection.vue?vue&type=template&id=de9cbfc2"
import script from "./LabsSection.vue?vue&type=script&lang=ts"
export * from "./LabsSection.vue?vue&type=script&lang=ts"
import style0 from "./LabsSection.vue?vue&type=style&index=0&id=de9cbfc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports